<template>
    <div>
        <div class="block--mobile">
            <table class="table--simple hidden-xs">
                <tbody v-for="section in sections">
                    <tr v-for="field in section">
                        <td class="td--large"><strong>{{localizeFieldName(field)}}</strong></td>
                        <td>{{getFieldValue(field)}}</td>
                    </tr>
                </tbody>
            </table>
            <div class="visible-xs" v-for="section in sections">
                <p v-for="field in section">
                    <strong>{{localizeFieldName(field)}}</strong>: {{getFieldValue(field)}}
                </p>
            </div>
        </div>

        <!-- <div class="col-12 col-xl-10 col-xxl-9"> -->
            <div class="alert--info adapted-width">
                {{$t('account_info.address_information')}}
                <a target="_blank" :href="contactUrl">{{$t('account_info.address_information_contact')}}</a>
            </div>
        <!-- </div> -->
        <router-link :to="{name: 'edit-account'}" class="button--cta">
            {{$t('account_info.button_edit')}}
        </router-link>
        <router-link :to="{name: 'change-password'}" class="button">
            {{$t('account_info.button_change_password')}}
        </router-link>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import {GET_FIELD} from '../../store/modules/account_details';
    import {exportDateShort} from '../../api/dateformat';

    @Component
    export default class ViewAccount extends Vue {
        created() {
            window.scrollTo(0,0);
        }
        get sections() {
            return [
                ['gender', 'first_name', 'last_name'],
                ['address', 'address_number', 'postal_code', 'city_name', 'country_name'],
                ['telephone_number', 'mobile_number', 'email_address'],
                ['guarantee'],
            ];
        }

        get contactUrl(){
            return this.$t('account_info.address_information_contact_url');
        }

        localizeFieldName(field) {
            return this.$t('form.account_info.label_' + field);
        }

        getFieldValue(field) {
            if (field === 'gender'){
                switch (this.$store.getters[GET_FIELD](field)) {
                case 'M':
                    return this.$t('common.account_title.M');
                case 'F':
                    return this.$t('common.account_title.F');
                default:
                    return '';
                }
            }
            if (field === 'guarantee') {
                const value = this.$store.getters[GET_FIELD](field);
                if (value === false) {
                    return this.$t('account_info.guarantee.unavailable');
                }
                if (value === null) {
                    return this.$t('account_info.guarantee.no-installation-moment-found');
                }
                const now = new Date();
                if (value > now) {
                    return this.$t('account_info.guarantee.active_until', {date: exportDateShort(value)});
                }
                return this.$t('account_info.guarantee.expired_on', {date: exportDateShort(value)});
            }
            return this.$store.getters[GET_FIELD](field);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/account/ViewAccount.vue